import "babel-polyfill";
import React from 'react';
import Dropdown from 'react-dropdown';
import { copy } from './functions.js';
// import "ie-array-find-polyfill";

class DesignerVarSelect extends React.Component {

    constructor(props) {
        super(props);

        const activeVar = this.props.activeDesignerVariants.find((activeVariant) => {
            return activeVariant.id == this.props.variant.id;
        });

        let defaultValue = this.props.variant.title + ':';
        if (activeVar !== undefined && activeVar !== null && activeVar.selectedVar !== null)
        {
            if (activeVar.isPersGroup == "1" && !activeVar.varUserSelected)
                defaultValue = this.props.variant.title + ': Bitte wählen';
            else
                defaultValue = activeVar.selectedVar.title;
        }

        this.state = {
            defaultValue: defaultValue,
            currentValue: ""
        }

        this.handleSelect = this.handleSelect.bind(this);
    }

    componentDidUpdate() {

        const activeVar = this.props.activeDesignerVariants.find((activeVariant)=>{
            return activeVariant.id == this.props.variant.id;
        });

        let currentValue = this.props.variant.title + ':';
        if (activeVar !== undefined && activeVar !== null && activeVar.selectedVar !== null)
        {
            currentValue = activeVar.selectedVar.title;

            if (activeVar.isPersGroup == "1" && !activeVar.varUserSelected)
                currentValue = this.props.variant.title + ': Bitte wählen';
            else
                currentValue = activeVar.selectedVar.title;
        }

        if (currentValue != this.state.currentValue)
        {
            this.setState({
                currentValue: currentValue
            });
        }
    }

    handleSelect(variant) {
        
        const newVar = copy(this.props.variant);
        const selectedVar = this.props.variant.vars.find((selvar) => {
            return selvar.id == variant.value
        });

        newVar.selectedVar = selectedVar
        newVar.varUserSelected = true;
        this.props.onVarSelect(newVar);

        this.setState({
            currentValue: selectedVar.title
        });

    }

    render() {

        let options = this.props.variant.vars.map((variant) => {
            return {
                value: variant.id,
                label: variant.title
            }
        });

        return (
            <Dropdown 
                options={options} 
                onChange={this.handleSelect} 
                value={this.state.currentValue}
                placeholder={this.state.defaultValue} 
            />
        );
    }
  }
export default DesignerVarSelect;



// WEBPACK FOOTER //
// ./src/DesignerVarSelect.js